import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const DatasourceUpdatedToast = ({ name }) => (
  <PositiveToast className="aridhia-datasource-updated-toast">
    <FormattedMessage id="toast.datasource.settings" values={{ name }} />
  </PositiveToast>
);

export default DatasourceUpdatedToast;
